import {
  AdvancedSearchFieldConfig,
  AdvancedSearchGroupConfig,
} from "./advanced-search-fields-def";

/**
 * i18n key for artist last name in the sort selector.
 * Client adds in DB, e.g. FR: "Nom Artistes & auteurs".
 */
export const ARTIST_LAST_NAME_SORT_LABEL = "advancedSortArtistesAuteursNom";

/** Sort key for artist last name on entities with a direct relatedAuthor relation. */
export const RELATED_AUTHOR_LAST_NAME_SORT_KEY =
  "relatedAuthor.some.artistesAuteursDescriptionNom";

/** Sort key for artist last name on tirages (via linked artwork). */
export const ARTWORK_RELATED_AUTHOR_LAST_NAME_SORT_KEY =
  "artwork.relatedAuthor.some.artistesAuteursDescriptionNom";

/** Sort key for artist last name on sculpture editions (via master artwork). */
export const MASTER_ARTWORK_RELATED_AUTHOR_LAST_NAME_SORT_KEY =
  "masterArtwork.relatedAuthor.some.artistesAuteursDescriptionNom";

const artistLastNameSortFieldBase = {
  type: "string" as const,
  sortable: true,
  sortLabel: ARTIST_LAST_NAME_SORT_LABEL,
};

export const relatedAuthorLastNameSortField: AdvancedSearchFieldConfig = {
  ...artistLastNameSortFieldBase,
  key: RELATED_AUTHOR_LAST_NAME_SORT_KEY,
};

export const artworkRelatedAuthorLastNameSortField: AdvancedSearchFieldConfig = {
  ...artistLastNameSortFieldBase,
  key: ARTWORK_RELATED_AUTHOR_LAST_NAME_SORT_KEY,
};

export const masterArtworkRelatedAuthorLastNameSortField: AdvancedSearchFieldConfig =
  {
    ...artistLastNameSortFieldBase,
    key: MASTER_ARTWORK_RELATED_AUTHOR_LAST_NAME_SORT_KEY,
  };

export const artistLastNameSortGroup = (
  field: AdvancedSearchFieldConfig = relatedAuthorLastNameSortField,
): AdvancedSearchGroupConfig => ({
  type: "group",
  label: "artworkAuteurInfo",
  fields: [field],
});

/** Resolve i18n key for sort field display (export filters, etc.). */
export function getSortFieldTranslationKey(key: string) {
  if (key === RELATED_AUTHOR_LAST_NAME_SORT_KEY) return ARTIST_LAST_NAME_SORT_LABEL;
  if (key === ARTWORK_RELATED_AUTHOR_LAST_NAME_SORT_KEY)
    return ARTIST_LAST_NAME_SORT_LABEL;
  if (key === MASTER_ARTWORK_RELATED_AUTHOR_LAST_NAME_SORT_KEY)
    return ARTIST_LAST_NAME_SORT_LABEL;
  if (key === "artistesAuteursDescriptionNom") return ARTIST_LAST_NAME_SORT_LABEL;

  if (!key.includes(".")) return key;
  return key.split(".").pop() ?? key;
}
